import type { WalletGroupedAccounts } from '@polaris/core/models'
import { usePendingAccountActions } from '@/src/stores/accounts/detection'
import { AnimatedWalletLogo } from '../connect-wallet/animated-wallet-logo'
import { Button } from '../ui/button'
import {
  ListRow,
  ListRowSide,
  ListRowSideDescription,
  ListRowSideName,
} from '../ui/list-row'

interface PendingAccountRowProps {
  account: WalletGroupedAccounts
}

export const PendingAccountRow = ({ account }: PendingAccountRowProps) => {
  const { addPendingAccount, isAddingAccount } = usePendingAccountActions()

  return (
    <ListRow
      size='md'
      className='py-2 border border-border1'
      key={account.grouping_key}
    >
      <div className='flex items-center gap-4'>
        {account.provider_info.img && (
          <AnimatedWalletLogo
            logoUrl={account.provider_info.img}
            displayName={account.name}
            size={40}
          />
        )}
        <ListRowSide>
          <ListRowSideName>New wallet detected</ListRowSideName>
          <ListRowSideDescription>{account.name}</ListRowSideDescription>
        </ListRowSide>
      </div>
      <Button
        variant='secondary'
        size='sm'
        disabled={isAddingAccount}
        onClick={() => {
          void addPendingAccount(account)
        }}
      >
        Add
      </Button>
    </ListRow>
  )
}
